var map = {
	"./arrow-button.svg": 59997,
	"./arrow-profile.svg": 97081,
	"./bookmark.svg": 14253,
	"./burger.svg": 38851,
	"./calendar.svg": 31487,
	"./calendar2.svg": 58278,
	"./check-mark.svg": 22590,
	"./check.svg": 6547,
	"./clock.svg": 30874,
	"./close.svg": 63781,
	"./doc-with-cross.svg": 37911,
	"./email.svg": 49613,
	"./eye-close.svg": 69573,
	"./eye.svg": 55724,
	"./facebook.svg": 63643,
	"./instagram.svg": 5250,
	"./location.svg": 66159,
	"./person.svg": 79787,
	"./user.svg": 32502,
	"./vk.svg": 39787,
	"./work.svg": 50872
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36852;